module.exports = __webpack_public_path__ + "img/psychology.7c072c18.png";